// Constantes de dominio del módulo invoice. Empiezan por las reglas del archivo
// adjunto y la moneda, que estaban triplicadas en los tres diálogos de carga
// (ChargedInvoiceDialog, SendManualInvoicePublic, ResendInvoiceManual).

// Reglas del archivo de factura: tamaño máximo y tipos MIME aceptados (.pdf y .docx).
export const INVOICE_FILE = {
  MAX_SIZE_BYTES: 3_000_000,
  ALLOWED_MIME_TYPES: [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
};

// Moneda con la que se cargan las facturas (el backend solo maneja USD hoy).
export const INVOICE_CURRENCY = "USD";
